export const entityContext = {
  checkList: 'CHECKLIST',
  financialProduct: 'FINANCIAL_PRODUCT',
  genericMatrix: 'GENERIC_MATRIX',
  genericMatrixTemplate: 'GENERIC_MATRIX_TEMPLATE',
  incomeSchema: 'INCOME_SCHEMA',
  residualValueGrid: 'RESIDUAL_VALUE_GRID',
  subsidyMatrix: 'SUBSIDY_MATRIX'
};
export const entityContextRoutes = {
  CHECKLIST: 'genericEntityFlowChecklist',
  FINANCIAL_PRODUCT: 'genericEntityFlowFinancialProduct',
  GENERIC_MATRIX: 'genericEntityFlowGenericMatrix',
  GENERIC_MATRIX_TEMPLATE: 'genericEntityFlowGenericMatrixTemplate',
  INCOME_SCHEMA: 'genericEntityFlowIncomeSchema',
  RESIDUAL_VALUE_GRID: 'genericEntityFlowResidualValueGrid',
  SUBSIDY_MATRIX: 'genericEntityFlowSubsidyMatrix'
};
